import { render, staticRenderFns } from "./RichTextComponentWrapper.vue?vue&type=template&id=37fed1d0&"
import script from "./RichTextComponentWrapper.vue?vue&type=script&lang=ts&"
export * from "./RichTextComponentWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports